import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
// import { StudyListColumns } from "../../constants/Columns/StudyList";
import studylistContext from "../../context/studylist/StudylistContext";
import Filters from "./components/Filters/Filters";
import { initSearchDto } from "../../context/studylist/StudylistState";
import { initPaginationObjData } from "./helpers/initData";
import { handleDropDownClick } from "./helpers/helpingFunctions";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { isMobile } from "react-device-detect";
import themeContext from "../../context/theme/ThemeContext";
import StudyListTableContainer from "./components/StudyListTableContainer/StudyListTableContainer";
import MobileStudyListContainer from "./components/MobileStudyListContainer/MobileStudyListContainer";
import CXRNavTabs from "./components/CXRNavTabs/CXRNavTabs";
import StudyListNavTabs from "./components/StudyListNavTabs/StudyListNavTabs";
import ShimmerStudyList from "./components/ShimmerStudyList/ShimmerStudyList";
import { CUSTOM_STYLES, MODAL_TYPE, TABS } from "../../constants/Constants";
import userContext from "../../context/users/UserContext";
import loaderContext from "../../context/loader/LoaderContext";
import ClearIcon from "../../components/SVGComponents/ClearIcon";
import PeerReviewTabs from "./components/PeerReviewTabs/PeerReviewTabs";
import { updateUserSettings } from "../../service/UserService";
import ArchiveStudyAccessTabs from "./components/ArchiveStudyAccessTabs/ArchiveStudyAccessTabs";
import SavedTabs from "./components/SavedTab/SavedTabs";

const StudyList = () => {
  const {
    searchDto,
    setSearchDto,
    setSortGlobal,
    setStoreFilterBadges,
    setFilterBadges,
    roles,
    showCount,
    setPatientNameBadgeShow,
    setSearchResultLength,
    showGenericConfirmModal,
    setShowGenericConfirmModal,
    showConfirmModalState,
    setShowConfirmModalState,
    unreportedAllTabs,
    savedAllTabs,
    peerReviewAssignedTab,
    archivedStudyRequestTab,
    filterApplied,
    setFilterApplied,
    alertSuccessStudyListState,
    setAlertSuccessModalStudyListState,
    paginationObj,
    setPaginationObj,
    handleChangeSizeIndex,
    handleRefresh,
    filterInputValues,
    showShimmer,
    setStudyDateFrom,
    setStudyDateTo,
    noOfImagesFilter,
    historyCheckFilter,
    maintenance,
    setMaintenance,
    setReportDateFrom,
    setReportDateTo
  } = useContext(studylistContext);

  const {getConsistentDateFormat} = useContext(studyReportContext);

  const { userSettings, authenticated, contextSwitchUser , userId, setUserSettings} = useContext(userContext);

  const { setShowModal, showModal ,ref ,setLoaderRunning} = useContext(loaderContext);

  const { openReportModal, alertSuccessModal, setAlertSuccessModal } =
    useContext(studyReportContext);

  const { themeName, setThemeName } = useContext(themeContext);
  const [t] = useTranslation();
  const [dataQueryParent, setDataQueryParent] = useState(null);

  useEffect(() => {
    if (showGenericConfirmModal && showConfirmModalState) {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("confirm-message.no-study-selected");
        return newItem;
      });
    }
  }, [showGenericConfirmModal, showConfirmModalState]);

  useEffect(() => {
    if (!alertSuccessModal?.show) {
      if (showGenericConfirmModal) {
        setShowGenericConfirmModal(false);
        setShowConfirmModalState(false);
      }
    }
  }, [alertSuccessModal?.show]);

  useEffect(() => {
    if (document.getElementById("study_1") != null) {
      if (themeName != "light") {
        document.getElementById("study_1").style.border =
          CUSTOM_STYLES.ACTIVE_TAB;
          document.getElementById("study_1").style.background = "unset";
      } else if(themeName === "light") {
        // document.getElementById("study_1").style.border = "1px solid #d0d0d0";
        document.getElementById("study_1").style.background =
        TABS.ACTIVE_BACKGROUND;
      }

      document.getElementById("study_1").style.borderBottom =
        "1px solid rgba(0,0,255,0.1)";
      document.getElementById("study_1").style.borderRadius =
        "10px 10px 0px 0px";
     
    }
  }, [document.getElementById("study_1")]);

  useEffect(() => {
    document.title = "Study List (DeepTek)";
  }, []);

  useEffect(() => {
    if (alertSuccessStudyListState.show) {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = alertSuccessStudyListState.show;
        newItem.heading = alertSuccessStudyListState.heading;
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = alertSuccessStudyListState.isWarning;
        newItem.description = alertSuccessStudyListState.description;
        return newItem;
      });
    }
  }, [alertSuccessStudyListState.show]);

  useEffect(() => {
    if (!alertSuccessModal.show && alertSuccessStudyListState.show) {
      setAlertSuccessModalStudyListState(() => {
        const newItem = { ...alertSuccessStudyListState };
        newItem.show = false;
        return newItem;
      });
    }
  }, [alertSuccessModal.show]);

  useEffect(() => {
    if (dataQueryParent != null) {
      //handleChangeSizeIndex(0, 50, "");
      let filterUpdated = filterApplied + 1;
      setFilterApplied(filterUpdated);
      // setTimeout(() => {
      //   setPaginationObj(initPaginationObjData);
      // }, 100);
    }
  }, [showCount]);

  const handleClearFilter = () => {
    setStoreFilterBadges([]);
    setStudyDateFrom(new Date());
    setStudyDateTo(new Date());
    setFilterBadges([]);
    setSortGlobal({
      sortColumn: "assignment_created_date",
      sortOrder: "desc",
    });
    setReportDateFrom(new Date());
    setReportDateTo(new Date());
    handleChangeSizeIndex(0, 50, "");
    setTimeout(() => {
      setSearchResultLength(1);
      setPatientNameBadgeShow(false);
      // setSearchDto(initSearchDto);
      setSearchDto({ ...initSearchDto, noOfImages: noOfImagesFilter, historyChecks: historyCheckFilter });
    }, 100);

    setTimeout(() => {
      let filterUpdated = filterApplied + 1;
      setFilterApplied(filterUpdated);
    }, 200);
  };

  useEffect(() => {
    // console.log("--- User Setting ---",userSettings);
    if (authenticated && process.env.REACT_APP_HYBRID_MODE == "false") {
      if (
        userSettings == undefined ||
        userSettings == null ||
        userSettings?.studylistTour == false
      ) {
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.TOUR;
          return newItem;
        });
      }
      else if( userSettings?.showThemePreference == true) {
        changeTourUpdate(userSettings?.theme, true, userSettings?.viewerTour, false);
      }
    }
  }, [authenticated]);

  const changeTourUpdate = async(themeValue,studyListTour,viewerTour,showThemePreference) => {
      let body = {
        userSettings:{
          "theme":themeValue != null && themeValue != undefined ? themeValue : "dark-midnight",
          "studylistTour":studyListTour,
          "viewerTour":viewerTour != null && viewerTour != undefined ? viewerTour : false,
          "showThemePreference": showThemePreference != null && showThemePreference != undefined ? showThemePreference : false,
        }
      }
      try{
        setLoaderRunning(true);
        ref.current.continuousStart();
        const response = await updateUserSettings(body.userSettings,userId);
        if (response.status === 200 && response.data.result === "SUCCESS") {
            setUserSettings(body.userSettings);
            setLoaderRunning(false);
            ref.current.complete();
            setShowModal({ show: false });
            setTimeout(()=>{
              setShowModal({ show: true, type: MODAL_TYPE.THEME_PREFERENCE });
             },500)
        }else{
          setLoaderRunning(false);
          ref.current.complete();
        }
      }catch(e){
        setLoaderRunning(false);
        ref.current.complete();
      }
    }
  

  const handleHideMaintenance = () => {
    setMaintenance(() => {
      const newItem = {...maintenance, show: false};
      return newItem;
    })
    localStorage.setItem("showMaintenance", false);
  }

 
  return !isMobile ? (
    <>
      {maintenance?.show &&
        <div
          className="password-expiry-msg"
        >
          <span
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {maintenance?.message}
          </span>
          <div
            onClick={handleHideMaintenance}
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              cursor: "pointer",
            }}
          >
            <ClearIcon />
          </div>
        </div>
      }
      {showShimmer && <ShimmerStudyList />}
      {( (roles != undefined &&
        roles.length > 0 &&
        filterInputValues &&
        !showShimmer &&
        (unreportedAllTabs != undefined || peerReviewAssignedTab != undefined || archivedStudyRequestTab != undefined || savedAllTabs != undefined))) && (
          <div className="study-list-main-container" style={{height: maintenance?.show ? "calc(100% - 40px)" : "100%"}}>
            {
              !contextSwitchUser &&
              <Filters
              handleDropDownClick={handleDropDownClick}
              handleApplyFilter={handleRefresh}
              handleClearFilter={handleClearFilter}
            />
            }
            <StudyListNavTabs />
           {unreportedAllTabs != undefined && !contextSwitchUser &&<CXRNavTabs />}
           {peerReviewAssignedTab != undefined && !contextSwitchUser && <PeerReviewTabs/>}
           {archivedStudyRequestTab!= undefined && !contextSwitchUser && <ArchiveStudyAccessTabs/>}
           {savedAllTabs!= undefined && !contextSwitchUser && <SavedTabs/>}
           {/* { !contextSwitchUser &&<CXRNavTabs />} */}
            <StudyListTableContainer setDataQueryParent={setDataQueryParent} />
          </div>
        )}
    </>
  ) : (
    <>
      <MobileStudyListContainer
        paginationObj={paginationObj}
        handleChangeSizeIndex={handleChangeSizeIndex}
        setDataQueryParent={setDataQueryParent}
        handleRefresh={handleRefresh}
        handleDropDownClick={handleDropDownClick}
        handleClearFilter={handleClearFilter}
      />
    </>
  );
};

export default StudyList;
